// This file is auto generated. DO NOT TOUCH!

import {UpdateUserData} from "@/api";
import {UpdateExtensionDataFieldDesc} from "./types";

type DescType = {[s in keyof UpdateUserData]: UpdateExtensionDataFieldDesc};

export const updateExtensionInputFieldDescriptor: DescType = {
    notificationEmail: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    homeNumber: {
        permission: "edit_extension",
        businessOnly: true,
        requiredFeature: null,
    },
    mobileNumber: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    alias: {
        permission: "edit_admin_extension",
        businessOnly: false,
        requiredFeature: "alias",
    },
    alternateCallerNumberId: {
        permission: "edit_admin_extension",
        businessOnly: true,
        requiredFeature: null,
    },
    callLimit: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    callOriginationDenied: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: "callOriginationTerminationDenied",
    },
    callTerminationDenied: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: "callOriginationTerminationDenied",
    },
    callWaiting: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    cliro: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    connectedNumberPresentationRestrictionOverride: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    directInwardDialing: {
        permission: "edit_superuser_extension",
        businessOnly: true,
        requiredFeature: null,
    },
    directOutwardDialing: {
        permission: "edit_superuser_extension",
        businessOnly: true,
        requiredFeature: null,
    },
    displayName: {
        permission: "edit_admin_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    e164: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    featureRestrictions: {
        permission: "edit_admin_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    groupMembershipGroupIds: {
        permission: "edit_admin_extension",
        businessOnly: true,
        requiredFeature: null,
    },
    hotNumber: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: "hotNumber",
    },
    internationalCac: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: "enableCarrierAccessCodes",
    },
    locationId: {
        permission: "add_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    maliciousCallTrace: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: "maliciousCallTrace",
    },
    nationalCac: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: "enableCarrierAccessCodes",
    },
    nonPaymentBlockingType: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    outgoingCallBarringAdmin: {
        permission: "edit_admin_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    outgoingCallBarringOperator: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    outgoingCallBarringUser: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    pin: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    previewFeaturesEnabled: {
        permission: "edit_superuser_extension",
        businessOnly: false,
        requiredFeature: null,
    },
    privateRoutingType: {
        permission: "edit_superuser_extension",
        businessOnly: true,
        requiredFeature: null,
    },
    secretaryNumberId: {
        permission: "edit_admin_extension",
        businessOnly: true,
        requiredFeature: null,
    },
    voicemailToEmailEnabled: {
        permission: "edit_extension",
        businessOnly: false,
        requiredFeature: null,
    },
};
